const sat = 60;
const lum = 80;

/**
 * Layout breakpoints — aligned with Semantic UI / Fomantic:
 * mobile < tablet (768) ≤ computer (992) ≤ large (1200).
 * Used by SizeProvider, mediaQueries, and Grid.
 */
export const deviceSizes = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 992,
  laptopL: 1400,
  desktop: 2560,
};

/** Page container max-widths (no Semantic gutter / negative-margin math). */
export const containerWidths = {
  /** Default centred page container */
  default: 1366,
  /** Narrow text container */
  text: 700,
} as const;

export const colorMap = {
  red: `hsl(0deg ${sat}% ${lum}%)`,
  orange: `hsl(29deg ${sat}% ${lum}%)`,
  yellow: `hsl(43deg ${sat}% ${lum}%)`,
  olive: `hsl(68deg ${sat}% ${lum}%)`,
  green: `hsl(96deg ${sat}% ${lum}%)`,
  teal: `hsl(177deg ${sat}% ${lum}%)`,
  blue: `hsl(217deg ${sat}% ${lum}%)`,
  purple: `hsl(285deg ${sat}% ${lum}%)`,
  pink: `hsl(327deg ${sat}% ${lum}%)`,
  brown: `hsl(24deg ${sat}% ${lum}%)`,
  violet: `hsl(266deg 56% 68%)`,
  grey: `hsl(228deg 7% 85%)`,
  black: "hsl(0deg 0% 0%)",
  white: "hsl(0deg 0% 100%)",
  msteams: "#6264a7",
  facebook: "hsl(221deg 44% 41%)",
  linkedin: "hsl(200deg 72% 43%)",
  "google plus": "hsl(7deg 70% 55%)",
} as const;
